import { Box, HStack, Image, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { getImageURL } from '../util/getImage';
import Medium from '../Theme/Typography/Medium';
import ArchiveFilmDetails from './FullScreen/ArchiveFilmDetails';
import { isArray } from 'lodash';
import H2 from '../Theme/Typography/H2';
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const placeholderImg = `${IMAGE_BASE_PATH}/ui/DummyImage/small.png`;

const PreviewPage = ({artDetails, masterlistType, castCrewData, filmData, producerData, archiveLoader}) => {

    return (
        <Stack
        width={{base:"100%",md:"450px"}}
        marginTop={{ base: "15px", md: "0" }}
        marginX={{ base: "20px", md: "30px" }}
        flexDirection={{ base: "column", md: "column" }}
        gap={{base:"0",md:"8"}}

      >
      <Stack p={{base:"4",md:"8"}}
        border={"0.01rem solid #b3b3b3"}
        borderRadius={"5px"}
        >
        <HStack
          width={{ base: "100%", md: "100%" }}
          justifyContent={"center"}
        >
          <Stack mb={4} >
          <Box
              display={"block"}
              justifyContent={"center"}
              width={{ base: "auto", md: "370px" }}
              height={{ base: "275px", md: "inherit" }}
           >
              <>
              { artDetails 
              && 
              artDetails?.video_link 
              ?
                <>
                    <Image
                    src={
                      getImageURL(
                      artDetails?.image !== ""
                        ? artDetails?.image
                        : artDetails?.imagePath,
                      370,
                      550
                    )}
                      fallbackSrc={placeholderImg}
                    width={"100%"}
                    height={"inherit"}
                    objectFit={"contain"}
                    alt=""
                    />
                {/* {activeIndex === index && !isPlaying &&  (
                  <Box
                  position="relative"
                  width="100%"
                  height="100%"
                  cursor="pointer"
                  onClick={() => setIsPlaying(true)} // Trigger the video play logic
                >
                  <Image
                  src={getImageURL(
                    artDetails?.image !== ""
                      ? artDetails?.image
                      : artDetails?.imagePath,
                    650,
                    550
                  )}
                  fallbackSrc={placeholderImg}
                  alt="Custom Thumbnail"
                  width={{ base: "auto", md: "600px" }}
                  height="100%"
                  objectFit="contain"
                  cursor="pointer"
                  onClick={() => setIsPlaying(true)} // Play video when clicked
                />
                 <Box
                      position="absolute"
                      top="50%"
                      left="50%"
                      transform="translate(-50%, -50%)"
                      zIndex="2"
                      bg="rgba(0, 0, 0, 0.6)" // Optional background overlay for the icon
                      p={2}
                      borderRadius="50%"
                      background={"white"}
                    >
                      <FaYoutube style={{ color: "red", fontSize: "2rem" ,background:"white" }} />
                    </Box>

                </Box>
              )} */}
                  {/* {activeIndex === index && isPlaying && <Box
                    width="100%"
                    height="100%"
                  >
                    <YouTube
                      videoId={getVideoId(artDetails?.video_link)}
                      opts={opts}
                      onReady={onReady}
                      />
                  </Box>} */}
                </>
                  :
                    <Image
                    src={
                      getImageURL(
                      artDetails?.image !== ""
                        ? artDetails?.image
                        : artDetails?.imagePath,
                      370,
                      550
                    )}
                      fallbackSrc={placeholderImg}
                    width={"100%"}
                    height={"inherit"}
                    objectFit={"contain"}
                    alt=""
                    />
                }
              </>
            </Box>
          </Stack>
        </HStack>
        {/* Don't show auction estimates if video link is present */}
        { artDetails 
              && 
              !artDetails?.video_link &&
              <>
                <HStack px={{base:"0px",md:"64px"}}>
                        {artDetails?.auction_estimates && (
                          <HStack gap="10" alignItems={"flex-start"} flexDirection={"row"} pt={4}>
                          {artDetails?.auction_estimates?.length > 0 &&
                            artDetails?.auction_estimates?.map((it, index) => {
                              // Check if at least one value is not empty
                              const hasValidData = it?.value_in_inr || it?.valuein_dollar || it?.value;

                              return (
                                
                                hasValidData && (
                                  <Stack key={`${it?.display}-${index}`}>
                                    {it?.display && <Medium>{it.display}</Medium>}
                                    {it?.value_in_inr && <Medium fontWeight="700">₹{it.value_in_inr}</Medium>}
                                    {it?.valuein_dollar && <Medium as="span">${it.valuein_dollar}</Medium>}
                                    {it?.value && <Medium fontWeight="700">{it.value}</Medium>}
                                  </Stack>
                                )
                              );
                            })}
                        </HStack>
                        )}
                </HStack>
              </>
              }
        </Stack>
        <HStack
          alignItems={"flex-start"}
          width={{ base: "100%", md: "500px" }}
          flexDirection={"column"}
        >
          {artDetails?.fullImageTitle && (
            <Box
              paddingBottom={"10px"}
              width={"100%"}
              borderBottom={"1px"}
              borderColor={"#e8e8e8"}
            >
              <H2
                fontSize={{ base: "14px", md: "20px" }}
                fontWeight={"700"}
                color={"color.blue"}
                style={{
                  display: '-webkit-box',
                  overflow: 'hidden',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 3,
                  height:"inherit"
                }}
              >
                {artDetails?.fullImageTitle}
              </H2>
            </Box>
          )}
          {/* Need for future use */}
          {masterlistType === "film" ? (
          <Stack
            pb="4"
            marginInlineStart={"0rem!important"}
            borderBottom={
              artDetails?.cineData &&
              "1px solid #e8e8e8"
            }
            width={"100%"}
            gap={0}
          >
            {
            <>
            {artDetails?.cineData &&
              artDetails?.cineData?.length > 0 &&
              artDetails?.cineData?.map((it) => (
                <>
                {it?.key === "facial_recognition_derived_title_of_artwork" ? (
                      <HStack className="mt-0 px-0">
                      <Text
                         fontSize={{ base: "12px", md: "16px" }}
                        fontWeight={"700"}
                        color="black"
                      >
                        {it?.value &&
                          `${it?.value}`}
                      </Text>
                    </HStack>
                ) : (
                <>
                {it?.value && (
                    <Stack
                      marginInlineStart={
                        "0rem!important"
                      }
                      py="1"
                      gap={"0"}
                      className="mt-0 px-0"
                      flexDirection={"column"}
                    >
                      <HStack className="mt-0 px-0">
                        <Text
                           fontSize={{ base: "12px", md: "16px" }}
                          fontWeight={"700"}
                          color="black"
                        >
                          {it?.display &&
                            `${it?.display}`}
                        </Text>
                        {it?.value && (
                          <Text
                            fontSize={{ base: "12px", md: "16px" }}
                            fontWeight={"400"}
                            color="color.blue"
                            // color="#035DA1"
                          >
                            {`${it?.value}`}
                          </Text>
                        )}
                      </HStack>
                    </Stack>
                    )}
                  </>
                )}
                </>
              ))}

              {/* Featured data */}
              {artDetails?.featured &&
                  artDetails?.featured?.length > 0 &&
                  artDetails?.featured?.map((it) => (
                    <>
                  {it?.value && (
                    <Stack
                      marginInlineStart={
                        "0rem!important"
                      }
                      py="1"
                      gap={"0"}
                      className="mt-0 px-0"
                      flexDirection={"column"}
                    >
                      <HStack className="mt-0 px-0" flexWrap={"wrap"} gap={"5px"}>
                        <Text
                           fontSize={{ base: "12px", md: "16px" }}
                          fontWeight={"700"}
                          color="black"
                        >
                          {it?.display &&
                            `${it?.display}`}
                        </Text>
                          {it?.value?.map((keyword, index) => (
                            <Text
                            fontSize={{ base: "12px", md: "16px" }}
                            fontWeight={"400"}
                            color="color.blue"
                          >{keyword}
                            {index < it?.value?.length - 1 && ' | '}
                          </Text>
                        ))}
                      </HStack>
                    </Stack>
                  )}
                  </>
                  )
                  )}
              {/* Featured data end */}
              <ArchiveFilmDetails
                archive={true}
                archiveLoader={archiveLoader}
                castData={castCrewData}
                filmData={filmData}
                producerData={producerData}
              />
              </>  
            }
          </Stack>
          )
          : (
          <Stack
            pb="4"
            marginInlineStart={"0rem!important"}
            borderBottom={
              artDetails?.essayistData &&
              "1px solid #e8e8e8"
            }
            width={"100%"}
            gap={0}
          >
            {
            <>
            {artDetails?.essayistData &&
              artDetails?.essayistData.length > 0 &&
              artDetails?.essayistData.map((it) => (
                <>
                  {it?.value && (
                    <Stack
                      marginInlineStart={
                        "0rem!important"
                      }
                      py="1"
                      gap={"0"}
                      className="mt-0 px-0"
                      flexDirection={"column"}
                    >
                      <HStack className="mt-0 px-0">
                        <Text
                           fontSize={{ base: "12px", md: "16px" }}
                          fontWeight={"700"}
                          color="black"
                        >
                          {it?.display &&
                            `${it?.display}:`}
                        </Text>
                        {it?.value && (
                          <Text
                            fontSize={{ base: "12px", md: "16px" }}
                            fontWeight={"400"}
                            // color="#035DA1"
                          >
                            {`${it?.value}`}
                          </Text>
                        )}
                      </HStack>
                    </Stack>
                  )}
                </>
              ))}
              {/* <ArchiveFilmDetails
                archive={archive}
                archiveLoader={archiveLoader}
                castData={castData}
              /> */}
              </>                                    
          //     :
          //     <Stack py="20px">
          //          {Array.from({ length: skeletonCount }).map((_, index) => (
          //               <Text key={index} px="0px">
          //                 {[1, 2].map((_, idx) => (
          //                   <Skeleton 
          //                     key={idx} 
          //                     width="100%" 
          //                     height="20px" 
          //                     style={idx === 0 ? { marginRight: "8px" } : {}} 
          //                   />
          //                 ))}
          //               </Text>
          //               ))}
          //         </Stack>
            }
            {/* )} */}
          </Stack>
          )
          }
          {/* for film */}
        <Box
          py="2"
          className="ml-0"
          alignItems={"flex-start"}
          flexDirection={"column"}
        >
          {artDetails?.text1 && (
            <HStack
              alignItems={"flex-start"}
              maxH={{ base: "315px", md: "100%" }}
              overflowY={{
                base: "scroll",
                md: "hidden",
              }}
              className="mt-0 px-0"
            >
              <Text
                fontSize={"14px"}
                fontWeight={"400"}
                color="black"
              >
                {artDetails?.text1}
              </Text>
            </HStack>
          )}

        {/* Section 4 code start */}
        {artDetails?.section4?.length > 0 && (
          <Stack
            py="2"
            marginInlineStart="0rem!important"
            width="100%"
            borderBottom="1px"
            borderColor="#e8e8e8"
          >
            {artDetails?.section4
              .filter((it) => it?.value) // Filter out items with empty display and value
              .map((it, index) => (
                <Stack
                  marginInlineStart="0rem!important"
                  py="1"
                  gap="2"
                  key={`${it?.display}-${index}`}
                  className="mt-0 px-0"
                >
                  {it?.key !== "provenance" ? (
                  <HStack className="mt-0 px-0">
                    {it?.display && (
                      <Text
                        fontSize={{ base: "12px", md: "16px" }}
                        fontWeight="700"
                        color="black"
                      >
                        {`${it.display}:`}
                      </Text>
                    )}
                    {it?.value && (
                      <Text
                        fontSize={{ base: "12px", md: "16px" }}
                        fontWeight="400"
                      >
                        {it.value}
                      </Text>
                    )}
                  </HStack>
                  ) : 
                  (
                    <Stack className="mt-0 px-0">
                    {it?.display && (
                      <Text
                        fontSize={{ base: "12px", md: "16px" }}
                        fontWeight="700"
                        color="black"
                      >
                        {`${it.display}:`}
                      </Text>
                    )}
                    {it?.value && (
                      <Text
                        fontSize={{ base: "12px", md: "16px" }}
                        fontWeight="400"
                      >
                        {it.value}
                      </Text>
                    )}
                  </Stack>
                  )
                }
                </Stack>
              ))}
          </Stack>
        )}

        {/* Section 4 code END */}

        {/* Section 5 code start */}

        {artDetails?.quotation?.[0]?.value && (
          <Box maxH={"280px"} overflowY={"scroll"}>
              <>
              <Stack
                  marginInlineStart={"0rem!important"}
                  py="1"
                  gap={"2"}
                  className="mt-0 px-0"
                >
                <HStack className="mt-0 px-0">
                  <Text
                    fontSize={{ base: "12px", md: "16px" }}
                    fontWeight={"700"}
                    color="black">
                    {artDetails?.quotation?.[0]?.display}
                  </Text>
                </HStack>
                {/* <Medium lineHeight={"16.44px"}> */}
                <Text
                  fontSize={{ base: "12px", md: "16px" }}
                  fontWeight={"400"}>
                  {/* {expanded 
                  ? artDetails?.quotation?.[0]?.value 
                  : artDetails?.quotation?.[0]?.value && artDetails?.quotation?.[0]?.value?.length > MAX_LENGTH 
                  ? `${artDetails?.quotation?.[0]?.value.substring(0, MAX_LENGTH)}...` 
                  : artDetails?.quotation?.value
                  } */}
                </Text>
                {/* { artDetails?.quotation?.[0]?.value?.length > MAX_LENGTH && (
                  <Medium
                    pt="1"
                    marginInlineStart={"0px!important"}
                    fontWeight={"700"}
                    color="color.blue"
                    cursor={"pointer"}
                    onClick={toggleExpanded}>
                    {expanded ? common.READ_LESS : common.READ_MORE}
                  </Medium>
                )} */}
              </Stack>
              </>
            </Box>
          )}
        {/* Section 5 code end */}

          {isArray(artDetails?.content) ? (
            artDetails?.content.map((it) => (
              <Stack
                marginInlineStart={"0rem!important"}
                py="1"
                gap={"2"}
                className="mt-0 px-0"
              >
                <HStack className="mt-0 px-0">
                  <Text
                    fontSize={"14px"}
                    fontWeight={"700"}
                    color="black"
                  >
                    {it.display}
                  </Text>
                </HStack>
                {it.value && (
                  <HStack className="mt-0">
                    <Text
                      fontSize={"14px"}
                      fontWeight={"400"}
                    >
                      {it.value}
                    </Text>
                  </HStack>
                )}
              </Stack>
            ))
          ) : (
            <Text>{artDetails?.content}</Text>
          )}
        </Box>
      </HStack>
      
    </Stack>

    )
}

export default PreviewPage;